var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58498 0.5C9.43027 0.5 9.2819 0.561458 9.1725 0.670854C9.06311 0.780251 9.00165 0.928624 9.00165 1.08333V3.41667C9.00165 3.57138 8.94019 3.71975 8.83079 3.82915C8.7214 3.93854 8.57302 4 8.41831 4H2.82415L3.58248 3.2475C3.69233 3.13766 3.75403 2.98868 3.75403 2.83333C3.75403 2.67799 3.69233 2.52901 3.58248 2.41917C3.47264 2.30932 3.32366 2.24761 3.16832 2.24761C3.01297 2.24761 2.86399 2.30932 2.75415 2.41917L1.00415 4.16917C0.951041 4.22464 0.909412 4.29006 0.881649 4.36167C0.823305 4.50369 0.823305 4.66298 0.881649 4.805C0.909412 4.87661 0.951041 4.94202 1.00415 4.9975L2.75415 6.7475C2.80838 6.80217 2.87289 6.84557 2.94398 6.87519C3.01506 6.9048 3.09131 6.92005 3.16832 6.92005C3.24532 6.92005 3.32157 6.9048 3.39265 6.87519C3.46374 6.84557 3.52825 6.80217 3.58248 6.7475C3.63716 6.69327 3.68055 6.62875 3.71017 6.55767C3.73978 6.48659 3.75503 6.41034 3.75503 6.33333C3.75503 6.25633 3.73978 6.18008 3.71017 6.109C3.68055 6.03791 3.63716 5.97339 3.58248 5.91917L2.82415 5.16667H8.41831C8.88244 5.16667 9.32756 4.98229 9.65575 4.6541C9.98394 4.32591 10.1683 3.8808 10.1683 3.41667V1.08333C10.1683 0.928624 10.1069 0.780251 9.99746 0.670854C9.88806 0.561458 9.73969 0.5 9.58498 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEnter);
export default __webpack_public_path__ + "static/media/ic_enter.6a42231affbf9d4dfd1cb07ecae480ee.svg";
export { ForwardRef as ReactComponent };